<div class="container-list-materials">
  <div class="container-list-material-block">
    <ng-content></ng-content>
  </div>
</div>
